export const itemCounterStyle = {
  typography: {
    style: {
      color: '#B9B5D6',
      fontSize: '14px',
      fontWeight: '600',
      lineHeight: '24px',
    },
  },
};
